import ReactDOM from 'react-dom/client'
import Root from './Root'
import { ThemeProvider } from './context/theme_context'
import { StrictMode } from 'react'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <StrictMode>
    <ThemeProvider>
      <Root />
    </ThemeProvider>
  </StrictMode>
)
